import React from 'react';
import MainBlock from './MainBlock';
import { useEffect } from 'react';

// Use MainBlockLayout with showSecondaryBanner set to false
const AdmissionsPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, ["load"]);

    return (
        <>
        <div className='admissionsPageWrap'>
            {/* MainBlockLayout will handle the layout */}
            <MainBlock />
        </div>
        </>
    );
};

export default AdmissionsPage;